import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// JS Files

// Others File

const DaramTakmili = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="my-8 md:mx-20 bg-[#FA8443] md:rounded-xl p-4 relative">
        <div className="">
          <span
            className="text-2xl md:text-3xl mx-4 text-center text-white"
            style={{ fontFamily: "lale" }}
          >
            ثبت‌نام بیمه درمان تکمیلی
          </span>
          <div className="flex justify-between items-center mt-2">
            <span
              className="text-base md:text-xl mx-4 text-right md:text-center text-white mt-2 md:mt-4 block"
              style={{ fontFamily: "lale" }}
            >
              جهت ثبت‌نام بیمه درمان تکمیلی برای خود و افراد تحت تکفل از طریق دکمه
              ثبت‌نام اقدام نمایید.
            </span>
            <div
              className="border-2 border-[#61BED7] rounded-lg cursor-pointer bg-white transition-all hover:bg-slate-50 flex justify-center py-2 px-4"
              onClick={() => navigate("/darman-takmili-signup")}
            >
              <span className="font-bold text-[#505050]">ثبت‌نام</span>
            </div>
          </div>
          <div className="flex justify-between items-center mt-4">
            <span
              className="text-base md:text-xl mx-4 text-right md:text-center text-white mt-2 md:mt-4 block"
              style={{ fontFamily: "lale" }}
            >
              جهت پیگیری وضعیت درخواست بیمه درمان تکمیلی برای خود و افراد تحت تکفل از طریق دکمه
              پیگیری اقدام نمایید.
            </span>
            <div
              className="border-2 border-[#61BED7] rounded-lg cursor-pointer bg-white transition-all hover:bg-slate-50 flex justify-center py-2 px-4"
              onClick={() => navigate("/follow-up-takmili")}
            >
              <span className="font-bold text-[#505050]">پیگیری</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DaramTakmili;
